export default {
      id: "command-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.e22fd14f.svg#command",
      toString: function () {
        return this.url;
      }
    }